import api from './api';

class ResourceService {
    // Get all resources with filters
    async getResources(filters = {}) {
        const params = new URLSearchParams();

        if (filters.category) params.append('category', filters.category);
        if (filters.contentType) params.append('contentType', filters.contentType);
        if (filters.difficulty) params.append('difficulty', filters.difficulty);
        if (filters.search) params.append('search', filters.search);
        if (filters.sort) params.append('sort', filters.sort);
        if (filters.limit) params.append('limit', filters.limit);
        if (filters.page) params.append('page', filters.page);
        if (filters.tags) params.append('tags', filters.tags.join(','));

        const response = await api.get(`/resources?${params.toString()}`);
        return response.data;
    }

    // Get single resource by slug
    async getResourceBySlug(slug) {
        const response = await api.get(`/resources/${slug}`);
        return response.data;
    }

    // Get featured resources
    async getFeaturedResources(limit = 6) {
        const response = await api.get(`/resources/featured?limit=${limit}`);
        return response.data;
    }

    // Get resources by category
    async getResourcesByCategory(category) {
        const response = await api.get(`/resources/category/${category}`);
        return response.data;
    }

    // Get popular resources
    async getPopularResources(limit = 10) {
        const response = await api.get(`/resources/popular?limit=${limit}`);
        return response.data;
    }

    // Update user progress
    async updateProgress(resourceId, progressData) {
        const response = await api.post(`/resources/${resourceId}/progress`, progressData);
        return response.data;
    }

    // Toggle bookmark
    async toggleBookmark(resourceId) {
        const response = await api.post(`/resources/${resourceId}/bookmark`);
        return response.data;
    }

    // Rate resource
    async rateResource(resourceId, rating, feedback = null) {
        const response = await api.post(`/resources/${resourceId}/rate`, { rating, feedback });
        return response.data;
    }

    // Get user's bookmarked resources
    async getUserBookmarks() {
        const response = await api.get('/resources/my/bookmarks');
        return response.data;
    }

    // Get user's progress
    async getUserProgress() {
        const response = await api.get('/resources/my/progress');
        return response.data;
    }

    // Get user's completed resources
    async getUserCompletedResources() {
        const response = await api.get('/resources/my/completed');
        return response.data;
    }

    // Get all categories with counts
    async getCategoriesWithCounts() {
        const response = await api.get('/resources/categories/counts');
        return response.data;
    }

    // Admin: Create resource
    async createResource(resourceData) {
        const response = await api.post('/resources', resourceData);
        return response.data;
    }

    // Admin: Update resource
    async updateResource(resourceId, updateData) {
        const response = await api.put(`/resources/${resourceId}`, updateData);
        return response.data;
    }

    // Admin: Delete resource
    async deleteResource(resourceId) {
        const response = await api.delete(`/resources/${resourceId}`);
        return response.data;
    }
}

export default new ResourceService();
